import React from 'react';
import PropTypes from 'prop-types';
import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import GeneralSectionFieldItem from 'react/containers/pages/TicketDetails/TicketDetailsContainer/GeneralSectionFieldItem';
import Loading from 'react/components/Loading';
import resources from 'react/containers/pages/TicketDetails/ticketDetailsResources';
import { resourceFrom, formatDate, checkIfDataExist } from 'react/containers/pages/TicketDetails/ticketDetailsUtils';

const checkStatusData = (data) => {
  const ticketStatus = data.get('ticketStatus');
  if (ticketStatus) {
    return resourceFrom(resources.ticketStatus[ticketStatus]);
  }

  return checkIfDataExist(ticketStatus);
};

const renderFields = (data) => {
  if (data?.get && data.get('id')) {
    const createdDate = data?.get('created') && formatDate(data.get('created'));
    const dueDateDate = data?.get('dueDate') && formatDate(data.get('dueDate'));

    return (
      <>
        <FormSectionColumn>
          <GeneralSectionFieldItem
            label={resourceFrom(resources.ticketTitle)}
            content={checkIfDataExist(data?.get('title'))}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.created)}
            content={checkIfDataExist(createdDate)}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.ticketType)}
            content={checkIfDataExist(data?.getIn(['ticketType', 'description']))}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.dueDate)}
            content={checkIfDataExist(dueDateDate)}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.ticketStatus.label)}
            content={checkStatusData(data)}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.ticketResolution)}
            content={resourceFrom(
              checkIfDataExist(data?.getIn(['ticketResolution', 'description']))
            )}
          />
        </FormSectionColumn>
        <FormSectionColumn>
          <GeneralSectionFieldItem
            label={resourceFrom(resources.ticketDescription)}
            content={checkIfDataExist(data?.get('description'))}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.route)}
            content={checkIfDataExist(data?.getIn(['ticketLinked', 'route', 'description']))}
            link={`#/Route/edit/${data?.getIn(['ticketLinked', 'route', 'id'])}`}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.stop)}
            content={checkIfDataExist(data?.getIn(['ticketLinked', 'location', 'description']))}
            link={`#/Location/edit/${data?.getIn(['ticketLinked', 'location', 'id'])}`}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.driver)}
            content={checkIfDataExist(data?.getIn(['userCreated', 'name']))}
          />
          <GeneralSectionFieldItem
            label={resourceFrom(resources.attendant)}
            content={checkIfDataExist(data?.getIn(['userAssigned', 'name']))}
          />
        </FormSectionColumn>
      </>
    );
  }

  return <div>{resourceFrom(resources.dataNotFound)}</div>;
};

function GeneralSection(props) {
  const { isLoading, data } = props;

  return (
    <FormSection title="TicketDetails.section.general.title" className="generalSection">
      {isLoading
        ? <Loading />
        : renderFields(data)}
    </FormSection>
  );
}

GeneralSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.object
};

GeneralSection.defaultProps = {
  data: {}
};

export default React.memo(GeneralSection);
